import React, { useEffect, useState } from "react";
import {
  BUTTON_TYPES,
  Button,
  Flex,
  Heading,
  Spacer,
  Text,
} from "@badi/badi-components";
import { useInView } from "react-intersection-observer";
import { translate } from "base/shared/Localization";
import InjectHtml from "components/inject-html";
import Image from "components/Image";
import Reason from "./reason";
import {
  Anchor,
  ActionsWrapper,
  ContentWrapper,
  ImageWrapper,
  Reasons,
  Root,
} from "./styled-components";
import { activateDamageCoverage } from "./utils";

const DamageCoverage = ({
  connectionId,
  onClose,
  onDamageCoverageActivate,
}) => {
  const [enabled, setEnabled] = useState(false);
  const [termsRef, isInView] = useInView({
    triggerOnce: true,
  });

  const handleActivateClick = () => {
    activateDamageCoverage(connectionId);
    onDamageCoverageActivate();
    onClose();
  };

  useEffect(() => {
    if (!isInView) {
      return;
    }

    setEnabled(true);
  }, [isInView]);

  return (
    <Root>
      <ContentWrapper>
        <ImageWrapper alignself="center">
          <Image lazy={false} src="/assets/images/damage-coverage.svg" />
        </ImageWrapper>
        <Reasons as={Flex} direction="column">
          <Heading align="center" data-qa="dmg-cov-title" level="20-Bold">
            {translate("damage.coverage.screen_title")}
          </Heading>
          <Reason
            answer={translate("damage.coverage.screen_how.does.it.work.text")}
            dataQa="dmg-cov-how"
            question={translate(
              "damage.coverage.screen_how.does.it.work.title",
            )}
          />
          <Reason
            answer={translate("damage.coverage.screen_what.if.text")}
            dataQa="dmg-cov-what"
            question={translate("damage.coverage.screen_what.if.title")}
          />
          <Reason
            answer={translate("damage.coverage.screen_is.it.for.free.text")}
            dataQa="dmg-cov-free"
            question={translate("damage.coverage.screen_is.it.for.free.title")}
          />
          <Spacer top={2}>
            <Anchor
              data-qa="dmg-cov-terms"
              href={translate("sitemap.tc.link")}
              ref={termsRef}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Text body="14-Regular" inline={true}>
                <InjectHtml>
                  {translate("damage.coverage.screen_learn.more.cta")}
                </InjectHtml>
              </Text>
            </Anchor>
          </Spacer>
        </Reasons>
      </ContentWrapper>
      <ActionsWrapper>
        <Flex gutter={1} justify="flexEnd">
          <Button
            dataQa="dmg-cov-cancel"
            fullWidth={true}
            grow={1}
            onClick={onClose}
            variant={BUTTON_TYPES.SECONDARY}
          >
            {translate("damage.coverage.screen_cancel.cta")}
          </Button>
          <Button
            dataQa="dmg-cov-activate"
            disabled={!enabled}
            fullWidth={true}
            grow={1}
            onClick={handleActivateClick}
          >
            {translate("damage.coverage.screen_activate.cta")}
          </Button>
        </Flex>
      </ActionsWrapper>
    </Root>
  );
};

export default DamageCoverage;
